import { Service, inject } from '@angular/core'
import {
  GetClientStatsResponse,
  GetEventStatsResponse,
  GetSignUpStatsResponse,
  GetVersionResponse,
} from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class MetaApiService {
  private readonly api = inject(ApiService)

  getVersion(init?: RequestInit) {
    return this.api.fetchJson<GetVersionResponse>(`version`, { ...init })
  }

  getEventStats(init?: RequestInit) {
    return this.api.fetchJson<GetEventStatsResponse>(`stats/events`, { ...init })
  }

  getSignUpStats(init?: RequestInit) {
    return this.api.fetchJson<GetSignUpStatsResponse>(`stats/sign-ups`, { ...init })
  }

  getClientStats(init?: RequestInit) {
    return this.api.fetchJson<GetClientStatsResponse>(`stats/clients`, { ...init })
  }
}
